import React, { useState } from 'react';
import { PenTool } from 'lucide-react';
interface ActionPrompt {
  id: string;
  question: string;
}
interface ActionPlanProps {
  title: string;
  prompts: ActionPrompt[];
}
export function ActionPlan({
  title,
  prompts
}: ActionPlanProps) {
  const [answers, setAnswers] = useState<Record<string, string>>({});
  return <div className="my-10 overflow-hidden rounded-2xl bg-forest text-cream shadow-md" data-id="element-10">
      <div className="bg-forest/90 px-6 py-4 md:px-8 md:py-6 border-b border-white/10 flex items-center gap-3" data-id="element-11">
        <PenTool className="h-6 w-6 text-gold" data-id="element-12" />
        <h3 className="font-sans text-xl md:text-2xl font-semibold text-white m-0" data-id="element-13">
          {title}
        </h3>
      </div>
      <div className="p-6 md:p-8 space-y-6" data-id="element-14">
        {prompts.map(prompt => <div key={prompt.id} className="space-y-3" data-id="element-15">
            <label htmlFor={prompt.id} className="block font-serif text-lg text-cream/90" data-id="element-16">
              {prompt.question}
            </label>
            <input type="text" id={prompt.id} value={answers[prompt.id] || ''} onChange={e => setAnswers({
          ...answers,
          [prompt.id]: e.target.value
        })} className="w-full border-b-2 border-sage/40 bg-transparent px-0 py-2 font-sans text-lg text-white placeholder-cream/30 focus:border-gold focus:outline-none focus:ring-0 transition-colors" placeholder="Escribe tu respuesta aquí..." data-id="element-17" />
          </div>)}
      </div>
    </div>;
}